export enum SEARCH_SYMBOL_INSTRUMENT_TYPE {
    COMMON_STOCK = 'common_stock',
    FUTURE = 'future',
    OPTION = 'option',
    INDEX = 'INDEX',
    EQUITY = 'equity',
    ALL = 'all'
}

export enum OPTION_TYPE {
    call = 'CE',
    put = 'PE'
}

export enum OrderCategory {
    single = 'single',
    spread = 'spread',
}

export enum FilterOptions {
    expiry = 'expiry',
    strike_price = 'strike_price',
    basic = 'basic',
    monthly = 'monthly',
    weekly = 'weekly',
    empty = '',
    symbol = 'symbol',
    index = 'index'
}

export enum OffsetOptions{
    Current,
    Next,
    Far,
    FarFar, 
    
}

export enum StrikePriceFilter{
    ATM = 'ATM',
    basic = 'basic'
}